export default __webpack_public_path__ + "static/media/favicon-modified.ffc63b2f.ico";